import { appointmentFields } from './appointment.js';
import { occupiedRange, occupiesTeam } from './next-free-time.js';
/**
 * Ce que le créneau **recouvre** dans la journée de l'équipe (#431, #669) : le premier rendez-vous ou
 * point interne dont la plage chevauche la sienne, durée comprise — 14 h sous un rendez-vous de
 * 13 h à 16 h est déjà pris ; un séminaire prend ses journées entières (#670). Une plage qui
 * commence quand l'autre finit ne la recouvre pas.
 *
 * Les mêmes créneaux que `nextFreeTime` : un contrôle effectué garde le sien, une demande abandonnée
 * le rend. `except` écarte ce qu'on déplace — la demande d'un rendez-vous, ou le point interne
 * lui-même : on ne se recouvre pas soi-même.
 *
 * ⚠️ **Une alerte, jamais un refus** (M21) : l'appelant nomme ce qu'il trouve et laisse enregistrer.
 */
export function slotTaken(occupied, teamId, scheduledAt, durationMinutes, except) {
    const start = Date.parse(scheduledAt);
    const end = start + durationMinutes * 60_000;
    return (occupied.find((slot) => {
        const range = occupiedRange(slot);
        const self = slot.inquiry?.id ?? slot.id;
        return (range !== null &&
            occupiesTeam(slot, teamId) &&
            (except === undefined || self !== except) &&
            range.start < end &&
            range.end > start);
    }) ?? null);
}
/**
 * L'heure de Paris (`HH:MM`) où le créneau tient en entier, durée comprise, sans rien recouvrir
 * dans la journée des équipes nommées (#692) : celle demandée si elle est libre, sinon la fin de ce
 * qu'elle recouvre, et ainsi de suite. C'est l'heure que « Replanifier » propose quand un créneau est
 * déjà pris — après ce qu'il recouvre, et non après la dernière occupation du jour (`nextFreeTime`).
 *
 * Toutes les équipes à la fois : un point interne en réunit plusieurs (#576). `null` quand plus rien
 * ne se libère le jour dit.
 */
export function freeTimeFrom(occupied, teamIds, scheduledAt, durationMinutes, except) {
    const day = appointmentFields(scheduledAt)?.day;
    let start = Date.parse(scheduledAt);
    for (;;) {
        const at = new Date(start).toISOString();
        const ends = teamIds.flatMap((teamId) => {
            const taken = slotTaken(occupied, teamId, at, durationMinutes, except);
            return taken === null ? [] : (occupiedRange(taken)?.end ?? []);
        });
        if (ends.length === 0) {
            const free = appointmentFields(at);
            return free !== null && free.day === day ? free.time : null;
        }
        start = Math.max(...ends);
    }
}
//# sourceMappingURL=slot-taken.js.map